// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__3LV8y","description":"PatientConsentPreview_description__2VlHy"};